import Image from "next/image"

interface AvatarProps {
  name: string
  imageUrl?: string
  className?: string
}

export function Avatar({ 
  name, 
  imageUrl, 
  className = "" 
}: AvatarProps) {
  const defaultImage = "/placeholder.svg"

  return (
    <div className={`w-full h-full aspect-square rounded-lg overflow-hidden ${className}`}>
      <Image
        src={imageUrl || defaultImage}
        alt={name}
        width={400}
        height={400}
        className="w-full h-full object-cover"
        placeholder="blur"
        blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k="
      />
    </div>
  )
} 